const colors =  [
        "#7b64ff",
        "#68bc00",
        "#009ce0",
        "#D94F04",
        "#F29325",
        "#BDA523",
        "#E3C75F",
        "#F27457",
        "#A1C7E0",
        "#BF665E"
    ];


export default function Color(index) {
    if (index === undefined) return colors[Math.floor(Math.floor(colors.length) * Math.random())]
    return colors[index % colors.length]
}